// Central contact configuration — replace the placeholder values below when final details are ready.
export const CONTACT = {
  phone: "[PHONE NUMBER]",
  text: "[TEXT NUMBER]",
  whatsapp: "[WHATSAPP LINK]",
  serviceEmail: "[SERVICE REQUEST EMAIL]",
  driverEmail: "[DRIVER APPLICATION EMAIL]",
};

export const links = {
  call: `tel:${CONTACT.phone}`,
  text: `sms:${CONTACT.text}`,
  whatsapp: CONTACT.whatsapp,
  serviceMail: `mailto:${CONTACT.serviceEmail}`,
  driverMail: `mailto:${CONTACT.driverEmail}`,
};

export const btnPrimary =
  "inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-base font-semibold text-white brand-gradient shadow-lg shadow-teal-500/25 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/40 hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus:ring-4 focus:ring-teal-300/50";

export const btnSecondary =
  "inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-base font-semibold text-[#3B3A4E] bg-white border-2 border-[#3B3A4E]/12 transition-all duration-300 hover:border-[#00B4B4] hover:text-[#0891B2] hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-teal-200";
